import React, { useEffect, useLayoutEffect, useState } from 'react'
import "./SingleTicket.css";
import { Accordion, Chip, RadioGroup, CircularProgress, FormControlLabel, Radio, AccordionDetails, AccordionSummary, Button, LinearProgress, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
// import ProgressBar from "@ramonak/react-progress-bar";
import ArticleIcon from '@mui/icons-material/Article';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditRow from '../EditRow/EditRow';
import NextResParty from '../NextResParty/NextResParty';
import CancelIcon from '@mui/icons-material/Cancel';
import ChangeStatus from '../Status/ChangeStatus';
import { MentionsInput, Mention } from 'react-mentions';
import EditList from '../EditListAssign/EditList';
import accimg from '../images/accimg.png'
import EditAttachment from '../EditFile/EditAttachment';
import SideBar from '../SideBar/SideBar';
import axiosApiInstance from '../axios';
import AllTicketsHeader from '../AllTickets/AllTicketsHeader';
import Card from '@mui/material/Card';
import personImg from '../images/person_image.png';
import CheckRounded from "@mui/icons-material/CheckRounded";
import Close from '@mui/icons-material/Close';
import CheckCircle from "@mui/icons-material/CheckCircle";
import CancelRounded from "@mui/icons-material/CancelRounded";
import { dateTimeFormat } from '../utils/common';
import Multiselect from "multiselect-react-dropdown";
import Backdrop from '@mui/material/Backdrop'; 
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import _ from 'lodash';
import { saveAs } from 'file-saver';
import { Link } from "react-router-dom";


const SingleTicket = () => {
  const limit=3;
  let pageNumber=1;

  const location = useLocation();
  const id = location.pathname.split("/")[2];

  const [inputData, setInputData] = useState('');
  const [text, settext] = useState([]);

  const [ticketData, setTicketData] = useState([]);

  const [ticketComments, setTicketComments] = useState([])
  const [sugg, setSugg] = useState([])

  const textChange = (e) => {
    setInputData(e.target.value.split("@@@^^^").join(" "))
  }

  const [ticketAttachment, setTicketAttachments] = useState([])

  const [ticketQues, setTicketQues] = useState([])

  const [faq, setFaq] = useState([])

  const [responsible, setResponsible] = useState([])

  const [open, setOpen] = useState(false)

  const [showParty, setShowParty] = useState(false)

  const [showStatus, setShowStatus] = useState(false)

  const [showIgn, setShowIgn] = useState(false)

  const [showFile, setShowFile] = useState(false)

  const [timerDay, setTimerDay] = useState()
  const [timerHour, setTimerHour] = useState()
  const [timerMin, setTimerMin] = useState()
  // const [timerSec, setTimerSec] = useState()

  const [selectedUser, setSelectedUser] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [showAct, setShowAct] = useState(false);
  const [showComment, setShowComment] = useState(true);
  const [showApproval, setShowApproval] = useState(false);
  const [dispTab, setDispTab] = useState([]);
  const [approvalData, setApprovalData] = useState({});
  const [showSelectedUsers, setShowSelectedUsers] = useState([]);
  const [activityLoader, setActivityLoader] = useState(false);
  const [approvalLoader, setApprovalLoader] = useState(false);
  const [comment, setComment] = useState('');
  const [isApproveCommentErrMsg, setIsApproveCommentErrMsg] = useState(false);
  const [isApproveUserErrMsg, setIsApproveUserErrMsg] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [approverLoader, setApproverLoader] = useState(false);
  const [showApprover, setShowApprover] = useState(false);
  const [isApproverEdit, setIsApproverEdit] = useState(false);
  const employeeId = JSON.parse(localStorage.getItem('employeeId'));
  const userRoles = JSON.parse(localStorage.getItem('userRole'));
  const [higherRole, setHigherRole] = useState('User');
  const [assignOptions, setAssignOptions] = useState([]);
  const [assignValue, setAssignValue] = useState({});
  const [CategoryBasedData, setCategoryBasedData] = useState([]);


  useEffect(() => {
    if (userRoles?.includes('Super Admin')) {
      setHigherRole('Super Admin');
    } else if (userRoles?.includes('Admin')) {
      setHigherRole('Admin');
    } else {
      setHigherRole('User');
    }
  }, [userRoles]);

  useEffect(() => {
    if (showAct && dispTab.length === 0) {
      getactivityDetails();
    }
  }, [id, open, showParty, showStatus, showAct])

  const getactivityDetails = () => {
    setActivityLoader(true);
    axiosApiInstance.get(`/activity/${id}`)
      .then(res => {
        setDispTab(res.data.data);
        setActivityLoader(false);
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    if (showSelectedUsers.length > 0) {
      getApprovalData();
    }
  }, [showSelectedUsers]);

  const getApprovalData = () => {
    if (id) {
      setApprovalLoader(true);
      setTimeout(() => {
        axiosApiInstance
          .get(`/approval/${id}`)
          .then((response) => {
            if (response.data.succeeded) {
              setApprovalData(response.data.data);
              setApprovalLoader(false);
            } else {
              setApprovalData({});
            }
          })
          .catch((err) => console.log(err));
      }, 800);
    }
  }

  const onChangeAssignValues = (e, value) => {
    setAssignValue(value);
}

const savePeopleDetails = () => {
  let data = JSON.stringify({
      "ticketId": id,
      "assignId": assignValue.id,
  });

  axiosApiInstance.post('/ticket/AddAssignee', data).then(function (response) {
    if (response.data.succeeded) {
      getNextResponsiblePartyData();
    }
  }).catch((error) => {
      console.log('error : ', error);
  })
  setShowIgn(false);
}

  useEffect(() => {
    setIsApproverEditable(showSelectedUsers, approvalData);
  }, [showSelectedUsers, approvalData]);

  const setIsApproverEditable = (data, approvalStatus) => {
    setIsApproverEdit(true);
    if (ticketData.status === 'Work Completed' || ticketData.status === 'Closed') {
      setIsApproverEdit(false);
    } else {
      if (higherRole === 'Super Admin' || higherRole === 'Admin') {
        if (approvalStatus?.approved === 'Rejected' || approvalStatus?.approved === 'Approved') {
          setIsApproverEdit(false);
        }
      } else {
        data.forEach(element => {
          if (element.isApproved !== null) {
            setIsApproverEdit(false);
          }
        });
      }
    }
  };

  const getSmallString = (string) => {
    let newString = string.split('.');
    let resultString = (newString[0].length > 15 ? newString[0].substring(0, 15)?.concat('...') : newString[0]).concat(newString[0].length > 15 ? `(.${newString[1]})` : `.${newString[1]}`);
    return resultString;
  }

  const onShowClick = () => {
    setShowAct(true);
    setShowComment(false);
    setShowApproval(false);
  };

  const onComClick = () => {
    setShowAct(false);
    setShowComment(true);
    setShowApproval(false);
  };

  const onApprovalClick = () => {
    setShowAct(false);
    setShowComment(false);
    setShowApproval(true);
  };


  useEffect(() => {
    getTicketDetails();
  }, [id]);

  const getTicketDetails = () => {
    if (id) {
      setTimeout(() => {
      axiosApiInstance.get(`/ticket/${id}`)
        .then(res => {
          setTicketData(res.data.data);
          setTicketComments(res.data.data.comments);
          setTicketAttachments(res.data.data.attachments);
           setTicketQues(res.data.data.generalQandA.questions);
          setShowSelectedUsers([...res.data.data.approverDto]);
          setComment(res.data.data.approvalRequestDto.requestComment);
          setSelectedUser(res.data.data.approverDto[0]?.isAllUser ? 1 : 0);
        }).catch(err => console.log(err));
    }, 800)
    }
  }



  useEffect(() => {
    // add axios here
    axiosApiInstance.get(`/faq`)
      .then(res => setFaq((res.data.data)))
      .catch(err => console.log(err))
  }, [id])

  useEffect(() => {
    getNextResponsiblePartyData();
  }, [id])

  const getNextResponsiblePartyData = () => {
    // add axios here
    setTimeout(() => {
      axiosApiInstance.get(`/nextResponsible/${id}`)
        .then(res => setResponsible((res.data.data)))
        .catch(err => console.log(err))
    }, 800)
  }

  useEffect(() => {
    axiosApiInstance.get('/user/EmployeeList')
      .then(res => setSugg(res.data.data))
      .catch(err => console.log(err))
  }, [])

  let interval;
  const dateDue = ticketData ? dateTimeFormat(ticketData?.submittedDate) : 10
  // const subDue = ticketData ? ticketData.dueDate : 10
  // console.log('dateDue : ', dateDue);

  const startTimer = () => {
    setTimerData();

    interval = setInterval(() => {
      setTimerData();
    }, 60000)
  };

  useLayoutEffect(() => {
    if (dateDue) {
      startTimer();
    }
    return () => {
      clearInterval(interval);
    }
  }, [dateDue]);

  const setTimerData = () => {
    const finalDue = new Date(dateDue).getTime();

    const finalSub = (new Date().getTime());
    const distance = finalSub - finalDue === NaN ? 0 : finalSub - finalDue;

    const days = Math.floor((distance) / (24 * 60 * 60 * 1000));
    const hours = Math.floor((distance % (24 * 60 * 60 * 1000)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (60 * 60 * 1000)) / (1000 * 60));
    //  const seconds = Math.floor((distance % ( 60 * 1000))/(1000));
    setTimerDay(days);
    setTimerHour(hours);
    setTimerMin(minutes);
    //  setTimerSec(seconds)
  }

  const addComment = () => {
    if (!inputData) {

    } else {
      axiosApiInstance.post('/Comments', data).then(function (response) {

        if (response.data.succeeded) {
          getTicketDetails();
        }

      }).catch((error) => {
        console.error("Error:", error);
      });
      settext([...text, inputData]);
      setInputData('');
    }
  }
  const navigate = useNavigate();

  let data = JSON.stringify({
    "ticketId": id,
    "comments": inputData
  });

  const editTicket = () => {
    setOpen(!open)
  }

  const editParty = () => {
    setShowParty(!showParty)
  }

  const editStat = () => {
    setShowStatus(!showStatus)
  }

  const editIgn = () => {
    setShowIgn(!showIgn)
  }

  const editFile = () => {
    setShowFile(!showFile)
  }

  const downloadFile = (filename) => {
    axiosApiInstance.get(`/File/${id}/${filename}`, {responseType: 'blob'}).then(res => {
      if (res.status === 200) {
        let urlArray = res.config.url && res.config.url.split('/');
        let fileName = urlArray[urlArray.length - 1];
        let blob = new Blob([res.data], {type: 'application/octet-stream'});
        saveAs(blob, fileName);
      }
    }).catch((error) => {
      console.error("Error:", error);
    });
  };

  const deletefile = (fileName) => {
    if (window.confirm("Are you sure that you wanted to delete that file?")) {
      setTicketAttachments(ticketAttachment.filter(x => x.fileName !== fileName))

      let data = {
        "ticketId": `${id}`,
        "fileName": fileName
      }

      axiosApiInstance.post('/File/Delete', JSON.stringify(data)).then(res => {
        if (res?.data?.succeeded === true) {
          //  ticketAttachment.splice(0,1);
          //  setTicketAttachments(ticketAttachment);
        }
      }).catch((error) => {
        console.error("Error:", error);
      });
    }
  }

  const searchHandler = (searchTerm) => {
    setSearchTerm(searchTerm)
}

const onApprovalSave = () => {
  if (comment === '') {
    setIsApproveCommentErrMsg(true);
  }

  if (selectedValues.length <= 0) {
    setIsApproveUserErrMsg(true);
  }

  if (comment !== '' && selectedValues.length > 0) {
    setApproverLoader(true);

    let approversIds = selectedValues.map(item => item.id);

    let data = {
      "ticketId": id,
      "comment": comment,
      "approvalId": approversIds,
      "isAllUser": !!parseInt(selectedUser),
    };

    axiosApiInstance.post('/approval', JSON.stringify(data)).then(res => {
      if (res?.data?.succeeded === true) {
        setShowApprover(false);
        getTicketDetails();
        setApproverLoader(false);
        getApprovalData();
      }
    }).catch((error) => {
      console.error("Error:", error);
    });
  }
}

const onCommentChange = event => {
  setComment(event.target.value)
  if (event.target.value !== '') {
    setIsApproveCommentErrMsg(false);
  }
}

const onApproverExpandCancelClick = () => {
  setShowApprover(!showApprover);
  if (!showApprover) {
    setSelectedValues([...showSelectedUsers]);
  }
}

const inputEvent6 = (event) => {
  setSelectedValues(event);
  if (event.length > 0) {
    setIsApproveUserErrMsg(false);
  }
};

const onInputChange = _.debounce((e, value, fromApprover = false) => {
  if (value !== '') {
      axiosApiInstance
          .get(`/user/${value}`)
          .then((response) => {
              if (response.data.succeeded) {
                  let updatedArray = response.data.data.map(item => {
                    if (fromApprover) {
                      if (item.id !== employeeId || employeeId !== ticketData?.submittedId) {
                          return { id: item.id, name: item.display };
                      } else {
                          return null;
                      }
                    } else {
                      return { id: item.id, name: item.display };
                    }
                  });
                  setAssignOptions(updatedArray.filter(item => item !== null));
              }
          })
          .catch((err) => console.log(err));
  } else {
      setAssignOptions([]);
  }
}, 500);

const onChangeAssignValuesMultiSelect = (e, values, reason, detail) => {
  const seen = new Set();
  const filteredArr = values.filter(el => {
    const duplicate = seen.has(el.id);
    seen.add(el.id);
    return !duplicate;
  });
  setSelectedValues(filteredArr);
  if (values.length > 0) {
    setIsApproveUserErrMsg('');
  }
}
const div = document.createElement("div");
let article= [];
const GetCategoryBasedData = () => {
  
  axiosApiInstance.get(`/article/${pageNumber}/${limit}`)
  .then(res => 

   {  
     for (let key of res.data.data) {
      div.innerHTML = key.description;
       
      article.push({
          id: key.id,
          title: key.title,
          description: div.innerText,
        });
      }
     setCategoryBasedData(article)
    
    }    
   )
   .catch(error => console.log(error))
   
}
useEffect(() => {
  GetCategoryBasedData()
 
}, []);


  return (
    <>
      <AllTicketsHeader searchKeyword={searchHandler} term={searchTerm} />
      <SideBar />
      <div className="my-ticket">
        <div className="create-ticket-new">
          <Button className="back-btn" onClick={() => navigate(-1 ? -1 : "/content")} style={{
            backgroundColor: "#0A387D"
          }}
            variant="contained">Back</Button>
          <div className="my-ticket-bar">
            <span className="bar-title">
              ID {ticketData.ticketId}
            </span>
            <span>
              {ticketData.title}
            </span>
          </div>
        </div>
        <div className="my-ticket-area">
          <div className="div-left">
            <span className="my-span">ID - {ticketData.ticketId ? ticketData.ticketId : <LinearProgress />}</span>
            <span className="my-span-2">{ticketData.title ? ticketData.title : 'Loading Title'}</span>
            <div className="my-ticket-description">
              {ticketData.description ? ticketData.description : 'Loading Description'}
            </div>
            <div className="my-tickets-head">
              <span className={showComment ? "my-tickets-comments-head little" : "my-tickets-comments-head"} onClick={onComClick}>
                COMMENTS
              </span>

              <span className={showAct ? "my-tickets-comments-act little" : "my-tickets-comments-act"} onClick={onShowClick}>
                ACTIVITY
              </span>

              {showSelectedUsers.length > 0 &&
                  <span
                    className={
                      showApproval
                        ? "my-tickets-comments-act little"
                        : "my-tickets-comments-act"
                    }
                    onClick={onApprovalClick}
                  >
                    APPROVAL
                  </span>
                }
            </div>
            {showComment ?
              <div className="user-input-section">
                <MentionsInput className="mentions--multiLine" placeholder="Enter Comment" value={inputData} onChange={textChange}>
                  <Mention
                    trigger="@"
                    data={sugg}
                    markup="@__display__@@@^^^"
                    className="mention-dis"
                  />
                </MentionsInput>
                <button onClick={addComment}>Save</button>

                {
                  ticketComments.map((tixd, id) => (
                    <div className="comments-display" key={id}>
                      <div className="comment-head" >
                        <img src={tixd.profilePath ? tixd.profilePath : accimg} className="img-pro" />
                        <p className="title-comment">{tixd.fullName}</p>
                        <p className="title-note" >added a comment - </p>
                        <p className="title-time">{dateTimeFormat(tixd.createdDate)}</p>
                      </div>
                      <div className="comment-content format">
                        {tixd.comments}
                      </div>
                    </div>
                  )).sort().reverse()
                }
              </div>
              : showAct ?
              activityLoader ?
              <div className="st-activity-loader">
                      <CircularProgress />
                    </div>:
                <div className="user-input-section">
                  {dispTab.length < 1 ? "No Activity Yet" : dispTab.map((disp, id) =>
                  <div className="card-body">
                    <Card>
                    <div className={
                         (disp.status === "Opened" && "table-body opened") ||
                         (disp.status === "In-Progress" && "table-body Inprogress") ||
                         (disp.status === "Work Completed" && "table-body workcompleted") ||
                         (["Closed", "Re-Opened", "Pending For Approval"].includes(disp.status) && "table-body closed") ||
                         "table-body default" // Default class
                        } key={id}>
                      <span>Title <p>{disp.title}</p></span>
                      <span>Status <p>{disp.status}</p></span>
                      <span>Category <p>{disp.category}</p></span>
                      <span>Client <p>{disp.client}</p></span>
                      <span>Next Responsible <p>{disp.nextResponsible}</p></span>
                      <span>Project <p>{disp.project}</p></span>
                      <span>Priority <p>{disp.priority}</p></span>
                      <span>Created Date <p>{dateTimeFormat(disp.createdDate)}</p></span>
                    </div>
                    </Card>
                    </div>
                  )
                  }
                </div>
               :
               approvalLoader ?
               <div className="st-activity-loader">
                      <CircularProgress />
                    </div>:
              Object.keys(approvalData).length > 0 ?
              <div className="mytickets-approval-section-container">
                <div>
                  <b className="mytickets-approval-section-main-title">Approval Request</b>
                  <div className="mytickets-approval-user-container">
                    <div className="mytickets-approval-user-time-container">
                      <img className="mytickets-approver-person-image" src={personImg} />
                      <b className="mytickets-approval-section-user-name">{approvalData.approvalRequest.name}</b>
                      <b className="mytickets-approval-section-time">{approvalData.approvalRequest.requestedDate && dateTimeFormat(approvalData.approvalRequest.requestedDate)}</b>
                    </div>
                    <div style={{ paddingLeft: 25 }}>
                      <label className="mytickets-approval-section-description">{approvalData.approvalRequest.requestComment}</label>
                    </div>
                  </div>
                </div>
                <div>
                  <b className="mytickets-approval-section-main-title">Approval Response</b>
                  {approvalData.approvalResponse.map((item, index) =>
                    <div className="mytickets-approval-user-container">
                      <div className="mytickets-approval-user-time-container">
                        <img className="mytickets-approver-person-image" src={personImg} />
                        <b className="mytickets-approval-section-user-name">{item.name}</b>
                        <b className="mytickets-approval-section-time">{item.approvedDate && dateTimeFormat(item.approvedDate)}</b>
                        {item.isApproved === null ?
                          <div className="mytickets-approval-section-chip" style={{ padding: '3px 20px', backgroundColor: '#999' }}>
                            <label className="mytickets-approval-sub-chip-text">PENDING</label>
                          </div> : item.isApproved ?
                            <div className="mytickets-approval-section-chip">
                              <CheckRounded sx={{ color: '#FFF', backgroundColor: '#22A', borderRadius: 10, padding: 0, height: 15, width: 15 }} /> <label className="mytickets-approval-sub-chip-text">APPROVED</label>
                            </div> :
                            <div className="mytickets-approval-section-chip" style={{ backgroundColor: '#f0754d', paddingRight: 17 }}>
                              <Close sx={{ color: '#FFF', backgroundColor: '#db6139', borderRadius: 10, padding: 0, height: 15, width: 15 }} /> <label className="mytickets-approval-sub-chip-text">REJECTED</label>
                            </div>}
                      </div>
                      <div style={{ paddingLeft: 25 }}>
                        <label className="mytickets-approval-section-description">{item.responseComment}</label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              : null
            }
          </div>

          <div className="div-center">
            <div className="status-progress">
              <h1>
                Ticket Status
              </h1>
              {ticketData?.status !== 'Pending For Approval' && <span className="edit-span" onClick={editStat}>{showStatus ? <CancelIcon /> : "Edit"}</span>}
            </div>
            {
              showStatus ? 
              <ChangeStatus
                setIsTicketStatusChanged={(value = false) => {
                  if (value === true) {
                    getTicketDetails();
                    getactivityDetails();
                  }
                }}
                onStatChange={editStat}
                info={id}
                stat={ticketData.status}
                strtDate={ticketData.submittedDate} 
              /> : <span className={ticketData.status === 'Opened' && 'stat-open' || ticketData.status === 'Closed' && 'stat-close' || ticketData.status === 'In-Progress' && 'stat-progress' || ticketData.status === 'Work Completed' && 'stat-work' || ticketData.status === 'Pending For Approval' && 'stat-pending' || ticketData.status === 'New' && 'stat-new'} >{ticketData.status}</span>
            }

            <div className="my-timer">
              {ticketData.status === "Work Completed" ? <span> {ticketData.completionDate} </span> :
                <>
                  <label>{timerDay ? timerDay : 0} days</label>
                  <label style={{paddingLeft: 4}}>{timerHour ? timerHour : 0} hours</label>
                  {/* <span>{timerMin ? timerMin : 0}</span>m */}
                </>
              }
            </div>

            {/* <ProgressBar completed={25} completedClassName="my-progress-bar" /> */}

            <div className="add-attach">
              <h1>Attachment</h1>
              <span className="icon-attach" onClick={editFile}>{showFile ? <CancelIcon /> : "+"}</span>
            </div>
            {showFile ? 
            <EditAttachment
              setIsTicketStatusChanged={(value = false) => {
                if (value === true) {
                  getTicketDetails();
                }
              }}
              onfChange={editFile}
              info={id}
            /> : <>
              {ticketAttachment < 1 ? <p className='empty-attach'>None</p> : ticketAttachment.map((attach, id) => (

                <div className="single-attachment" key={id}>
                  <div className="attach-text">
                    <ArticleIcon className="attachment-icon" />
                    <div className="attachment-text"><p>{getSmallString(attach.fileName)}</p><p>{attach.size}</p></div>
                  </div>
                  <div className="attach-con">
                    <FileDownloadOutlinedIcon className="file-attach-icon" type='button' onClick={() => { downloadFile(attach.fileName) }}>Download</FileDownloadOutlinedIcon>
                    <DeleteOutlineOutlinedIcon className='delete-icon' type='button' onClick={() => deletefile(attach.fileName)} />
                  </div>
                </div>

              ))
              }
            </>
            }
            <div className="resParty-next">
              <h1>Next Responsible Party</h1>
              <span className="edit-span" onClick={editParty}>{showParty ? <CancelIcon /> : "Edit"}</span>
            </div>
            {!showParty ?
              <>
                {ticketData.nextResponsible === "" ? <p className="res-p">Next Responsible Party is Not Selected</p> : <p key={id} className="res-p">{ticketData.nextResponsible}</p>}
              </>
              : " "
            }
            {
              showParty ? 
              <NextResParty 
                setIsNextResPartyChanged={(value = false) => {
                  if (value === true) {
                    getTicketDetails();
                    getactivityDetails();
                  }
                }}
                onPartyChange={editParty} 
                info={id}
              />
                 : ''
            }

<div className="mytickets-approver-container">
              <div className="mytickets-approver-plus-container">
                <b className="mytickets-approver-text">Approver</b>
                {isApproverEdit &&
                <b onClick={onApproverExpandCancelClick}>
                  {showApprover ? <CancelIcon /> : "+"}
                </b>}
              </div>
              {!showApprover ?
                showSelectedUsers.length > 0 ?
                  <>
                    <div className="mytickets-approver-chips-container-main">
                      {showSelectedUsers.map((item, index) =>
                        <div className="mytickets-approver-chips-container">
                          <img className="mytickets-approver-person-image" src={personImg} /> <b className="myticets-approver-outside-chip-text">{item.name}</b> {item.isApproved === null ? null : item.isApproved ? <CheckCircle sx={{ color: '#44D' }} /> : <CancelRounded sx={{ color: '#D66' }} />}
                        </div>
                      )}
                    </div>
                    <RadioGroup className="mytickets-radio-buttons-container" row aria-label="priority" name="row-radio-buttons-group" value={selectedUser}>
                      <FormControlLabel disabled value={0} control={<Radio size="small" />} label='Any Approver' className="myticket-radio-button-label" />
                      <FormControlLabel disabled value={1} control={<Radio size="small" />} label='All Approvers' className="myticket-radio-button-label" />
                    </RadioGroup>
                  </>
                  :
                  <p class="empty-attach">None</p>
                :
                <div>
                  <textarea placeholder="Comment" value={comment} onChange={event => onCommentChange(event)} rows={2} className='mytickets-textarea-style' />
                  {isApproveCommentErrMsg && <label className="mytickets-validation-text">This field is required</label>}
                  <div className="mytickets-approver-sub-container">
                  <Autocomplete
                      id="free-solo-demo"
                      className="newticket-autocomplete-style"
                      freeSolo
                      multiple
                      value={selectedValues}
                      onChange={(event, value, reason, detail) => onChangeAssignValuesMultiSelect(event, value, reason, detail)}
                      duplicate={false}
                      onInputChange={(e, v) => onInputChange(e, v, true)}
                      options={assignOptions}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => <TextField {...params} placeholder='select' />}
                      renderTags={(values, getTagProps) => {
                      const seen = new Set();
                      const filteredArr = values.filter(el => {
                          const duplicate = seen.has(el.id);
                          seen.add(el.id);
                          return !duplicate;
                      });
                      return (
                          filteredArr.map((option, index) => (
                          <Chip label={option.name} {...getTagProps({ index })}></Chip>
                          ))
                      )
                      }}
                  />
                    {isApproveUserErrMsg && <label className="mytickets-validation-text">This field is required</label>}
                    <RadioGroup className="mytickets-radio-buttons-container" row aria-label="priority" name="row-radio-buttons-group" value={selectedUser} onChange={(e) => {
                      setSelectedUser(e.target.value);
                    }}>
                      <FormControlLabel value={0} control={<Radio size="small" />} label='Any User' className="myticket-radio-button-label" />
                      <FormControlLabel value={1} control={<Radio size="small" />} label='All User' className="myticket-radio-button-label" />
                    </RadioGroup>
                    <div className="mytickets-save-cancel-buttons">
                      <Button className="mytickets-save-button" onClick={onApprovalSave}>Save</Button>
                      <Button className="mytickets-cancel-button" onClick={() => {
                        setShowApprover(false);
                        setSelectedValues([...showSelectedUsers]);
                      }}>Cancel</Button>
                    </div>
                  </div>
                </div>
              }
            </div>

            <div className="mytickets-approval-status-container">
              <label className="mytickets-approval-status-title">Approval Status</label>
              <label className="mytickets-approval-status-text">{approvalData?.approved ? approvalData?.approved : <p class="empty-attach">None</p>}</label>
            </div>

            <div className="my-details-head">
              <h1>Details</h1>
              <span className="edit-span" onClick={editTicket}>{open ? <CancelIcon /> : "Edit"}</span>
            </div>
            <div className="my-details-content">
              {open ? 
              <EditRow
                setIsDetailsChanged={(value = false) => {
                  if (value === true) {
                    getTicketDetails();
                    getactivityDetails();
                  }
                }}
                onStateChange={editTicket}
                info={id}
              /> :
                <>
                  <div className="details-div"><span>ID</span> <p>{ticketData.ticketId}</p></div>
                  <div className="details-div"><span>Title</span> <p>{ticketData?.title && ticketData?.title?.length > 15 ? ticketData?.title?.substring(0, 15)?.concat('...') : ticketData?.title}</p></div>
                  <div className="details-div"><span>Project Tag</span> <p>{ticketData.projectTag}</p></div>
                  <div className="details-div"><span>Priority</span> <p>{ticketData.priority}</p></div>
                  <div className="details-div"><span>Category</span> <p>{ticketData.category}</p></div>
                  <div className="details-div"><span>Sub Category</span> <p>{ticketData?.subCategory && ticketData?.subCategory?.length > 15 ? ticketData?.subCategory?.substring(0, 15)?.concat('...') : ticketData?.subCategory}</p></div>
                  <div className="details-div"><span>Submitted By</span> <p>{ticketData.submittedBy}</p></div>
                  <div className="details-div"><span>Submitted Date</span> <p>{dateTimeFormat(ticketData.submittedDate, true)}</p></div>
                  <div className="details-div"><span>Due Date</span> <p>{dateTimeFormat(ticketData.dueDate, true)}</p></div>
                </>
              }

            </div>
            <div className="peep">
              <h1>People</h1>
              <p className="edit-p" onClick={editIgn}>{showIgn ? <CancelIcon /> : "Edit"}</p>
            </div>
            <div className="people">
            {showIgn ?
                <div className="at-approver-sub-container">
                    <Autocomplete
                        id="free-solo-demo"
                        className="at-autocomplete-style"
                        freeSolo
                        onChange={(event, value) => onChangeAssignValues(event, value)}
                        duplicate={false}
                        onInputChange={(e, v) => onInputChange(e, v)}
                        options={assignOptions}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => <TextField {...params} placeholder='select' />}
                    />
                    <div className="at-save-cancel-buttons">
                        <Button className="at-save-button" onClick={savePeopleDetails}>Save</Button>
                        <Button className="at-cancel-button" onClick={() => setShowIgn(false)}>Cancel</Button>
                    </div>
                </div> :
                <div className="people">
                    {responsible.map((nxt) => (
                        <div key={nxt.id} className="peo-frag">
                            <img
                                src={nxt.profilePath ? nxt.profilePath : accimg}
                                className="img-pro"
                            />
                            <p>{nxt.fullName}</p>
                        </div>
                    ))}
                </div>
            }

            </div>
          </div>

          <div className="div-right">
            <div className="faq-head">
              General Related Questions
            </div>
            <div className="acc-head-2">
              <p>TMS Related Q and A</p>
            </div>

            {CategoryBasedData.map((data, id) => (
              <div className="accordianstyle-duplicate" key={id}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography className="suggestion">
                       <Link style={{ color: 'inherit', textDecoration: 'inherit'}} to={`/Article/${data.id}`} target="_blank" > {data.id} -{data.title.substring(0,15)}</Link>
                        
                     </Typography>
                  </AccordionSummary>
                  
                    <AccordionDetails >
                      <Typography>
                        
                    <span >
                    {data.description.length>=50 ? data.description.substring(0,50).concat('...') : data.description} 
                   
                    </span>            
                      </Typography>
                    </AccordionDetails>
                  
                </Accordion>
              </div>
            ))
            }

            <div className="acc-head">
              <p>TMS Related Q and A</p>
            </div>

            {faq.map((gen, id) => (
              <div className="accordianstyle-duplicate" key={id}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography className="suggestion">{gen.question}</Typography>
                  </AccordionSummary>
                  {gen.answers.map((ans, id) => (
                    <AccordionDetails key={id}>
                      <Typography>
                        {ans.answers}
                      </Typography>
                    </AccordionDetails>
                  ))}
                </Accordion>
              </div>
            ))
            }


          </div>
        </div>
      </div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={approverLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  )
}

export default SingleTicket
